module.exports = __webpack_public_path__ + "img/news3.1edf56a0.png";